import { createContext } from "react";

export interface PageHeaderMeta {
  title: string;
  subtitle?: string;
}

interface PageHeaderContextValue {
  meta: PageHeaderMeta | null;
  setPageMeta: (m: PageHeaderMeta | null) => void;
}

export const PageHeaderContext = createContext<PageHeaderContextValue | null>(null);
